import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-policy__header">
          <h1>プライバシーポリシー</h1>
          <p className="privacy-policy__subtitle">
            株式会社Jool（以下「当社」）は、本ウェブサイト上で提供するサービス（以下「本サービス」といいます）における、
            ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
          </p>
        </div>

        <div className="privacy-policy__content">
          <section className="privacy-policy__section">
            <h2>1. 個人情報の定義</h2>
            <p>
              本プライバシーポリシーにおける「個人情報」とは、個人情報保護法第2条第1項により定義された個人情報、すなわち生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）を指します。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>2. 個人情報の収集について</h2>
            <h3>2.1 収集する個人情報</h3>
            <p>当社は、以下の個人情報を収集する場合があります：</p>
            <ul>
              <li>氏名、メールアドレス、会社名、部署名</li>
              <li>サービス利用履歴、アクセスログ</li>
              <li>評価データ、分析結果</li>
              <li>お問い合わせ内容</li>
              <li>その他サービス提供に必要な情報</li>
            </ul>

            <h3>2.2 収集方法</h3>
            <p>個人情報は、以下の方法により収集いたします：</p>
            <ul>
              <li>サービス利用時の入力フォーム</li>
              <li>お問い合わせフォーム</li>
              <li>Cookie等のWebトラッキング技術</li>
              <li>その他適法な方法</li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2>3. 個人情報の利用目的</h2>
            <p>当社は、収集した個人情報を以下の目的で利用いたします：</p>
            <ul>
              <li>サービスの提供、運営、改善</li>
              <li>お客様からのお問い合わせへの対応</li>
              <li>サービスに関する重要な通知の送信</li>
              <li>利用状況の分析、統計データの作成</li>
              <li>不正利用の防止、セキュリティの確保</li>
              <li>法令に基づく義務の履行</li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2>4. 個人情報の第三者提供</h2>
            <p>
              当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
            </p>
            <ul>
              <li>法令に基づく場合</li>
              <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
              <li>予め次の事項を告知あるいは公表し、かつ当社が個人情報保護委員会に届出をしたとき
                <ul>
                  <li>利用目的に第三者への提供を含むこと</li>
                  <li>第三者に提供されるデータの項目</li>
                  <li>第三者への提供の手段又は方法</li>
                  <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
                  <li>本人の求めを受け付ける方法</li>
                </ul>
              </li>
            </ul>
          </section>

          <section className="privacy-policy__section">
            <h2>5. 外部サービスの利用について</h2>
            <p>
              当社は、以下の外部サービスを利用しており、これらのサービスにおいて個人情報が取り扱われる場合があります：
            </p>
            <ul>
              <li><strong>決済サービス（Stripe）</strong>：決済処理のため、Stripe, Inc.が提供する決済サービスを利用しています。決済情報（クレジットカード情報等）は、Stripeに直接提供され、当社のサーバーを経由しません。Stripeのプライバシーポリシーについては、Stripeのウェブサイトをご確認ください。</li>
            </ul>
            <p>
              これらの外部サービスは、それぞれ独自のプライバシーポリシーを有しており、個人情報の取扱いについては各サービスのプライバシーポリシーが適用されます。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>6. 個人情報の管理</h2>
            <p>
              当社は、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行います。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>7. 個人情報の開示・訂正・削除等</h2>
            <p>
              お客様は、当社の保有する自己の個人情報を開示するよう請求することができます。
            </p>
            <p>
              当社に対する個人情報の開示請求は、以下の方法により受け付けます。
            </p>
            <ul>
              <li>申請方法：本ポリシー末尾記載の問い合わせ窓口への電子メール</li>
              <li>開示手数料：無料</li>
            </ul>
            <p>
              開示請求により、万一個人情報の内容が事実でないことが判明した場合には、速やかに訂正又は削除に応じるものとします。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>8. Cookie（クッキー）について</h2>
            <p>
              当社は、本ウェブサイトにおいて、Cookie及び類似技術を利用しています。
            </p>
            <p>
              Cookieとは、ウェブサイトを利用したときに、ブラウザとサーバーとの間で送受信される小さなテキストデータのことです。当社は、以下の目的でCookieを利用しています：
            </p>
            <ul>
              <li>ログイン状態の維持</li>
              <li>お客様の設定情報の記憶</li>
              <li>セキュリティの確保</li>
              <li>利用状況の分析</li>
            </ul>
            <p>
              お客様は、ブラウザの設定により、Cookieの受け入れを拒否することができます。ただし、Cookieを無効にすることで、当社のサービスの一部の機能をご利用いただけなくなる場合があります。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>9. 未成年者の個人情報について</h2>
            <p>
              未成年者が本サービスを利用し、個人情報を入力される場合は、必ず保護者の方の同意を得た上で行ってください。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>10. プライバシーポリシーの変更</h2>
            <p>
              本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
            </p>
            <p>
              当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>
          </section>

          <section className="privacy-policy__section">
            <h2>11. お問い合わせ窓口</h2>
            <p>
              本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
            </p>
            <div className="contact-info">
              <p><strong>株式会社Jool</strong></p>
              <p>〒604-8276</p>
              <p>京都市中京区壺屋町442 高橋ビル4F</p>
              <p>代表取締役・個人情報保護管理者：平岡弦己</p>
              <p>メールアドレス：info@jool.jp</p>
            </div>
          </section>
        </div>

        <div className="privacy-policy__footer">
          <p>制定日：2024年1月1日</p>
          <p>最終更新日：2025年11月27日</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;